/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 25/01/2021
 */
import * as SessionUtils from './../../../core/session_utils.js'

const detailsOrderRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        item_id: 0,
        index: 0
    }
}

export default detailsOrderRequest;